import { getCookie } from "@soenergy/frontend-library/src/services/Cookies.js"
import dayjs from "dayjs"

export const EV_ELIGIBILITY_BYPASS_COOKIE = "bypassEvEligibilityChecks"

export const isEvEligibilityBypassed = (): boolean =>
  getCookie(EV_ELIGIBILITY_BYPASS_COOKIE) === "true"

export type EvEligibilityCheckState =
  | "loading"
  | "noConsent"
  | "noHHData_warmingUp"
  | "noHHData_meterIssue"
  | "error"
  | "pass"

export interface ConsentEntry {
  "meter-point-id": number | string
  frequency: string
}

export interface EnergyUsageValue {
  startDate?: string
  kwh?: number | null
}

export interface EnergyUsageEntry {
  meterpointId: number | string
  values?: EnergyUsageValue[]
}

export const EV_ELIGIBILITY_FAIL_THRESHOLD_DAYS = 5
export const EV_ELIGIBILITY_HH_SLOTS_PER_DAY = 48
export const EV_ELIGIBILITY_REQUIRED_HH_READS = EV_ELIGIBILITY_HH_SLOTS_PER_DAY
export const EV_ELIGIBILITY_WINDOW_START_HOURS_AGO = 48
export const EV_ELIGIBILITY_WINDOW_END_HOURS_AGO = 24

export const EV_ELIGIBILITY_TRACKING_EVENT = "renewalEvHhEligibilityCheck"
export const EV_VEHICLE_ELIGIBILITY_TRACKING_EVENT =
  "renewalEvVehicleEligibilityCheck"
export const EV_METER_ELIGIBILITY_TRACKING_EVENT =
  "renewalEvMeterEligibilityCheck"

export const EV_SMART_HH_ELIGIBILITY_TRACKING_EVENT =
  "renewalEvSmartHhEligibilityCheck"
export const EV_SMART_VEHICLE_ELIGIBILITY_TRACKING_EVENT =
  "renewalEvSmartVehicleEligibilityCheck"
export const EV_SMART_METER_ELIGIBILITY_TRACKING_EVENT =
  "renewalEvSmartMeterEligibilityCheck"
export const EV_SMART_CHARGING_ELIGIBILITY_TRACKING_EVENT =
  "renewalEvSmartChargingEligibilityCheck"
export const EV_SMART_ELIGIBILITY_MODAL_OPENED_TRACKING_EVENT =
  "renewalEvSmartEligibilityModalOpened"

export const countValidHHSlots = (
  data: EnergyUsageEntry[] | undefined,
  meterPointId: number | string
): number => {
  const validSlots = new Set<string>()
  for (const entry of data ?? []) {
    if (String(entry.meterpointId) !== String(meterPointId)) continue
    for (const v of entry.values ?? []) {
      if (v?.kwh != null && v.startDate) validSlots.add(v.startDate)
    }
  }
  return validSlots.size
}

export const evNoHHDataState = (
  supplyStartDate: string | undefined
): EvEligibilityCheckState => {
  if (!supplyStartDate) return "noHHData_meterIssue"
  const daysSinceSupplyStart = Math.max(
    0,
    dayjs().diff(dayjs(supplyStartDate), "day")
  )
  return daysSinceSupplyStart <= EV_ELIGIBILITY_FAIL_THRESHOLD_DAYS
    ? "noHHData_warmingUp"
    : "noHHData_meterIssue"
}
